var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CheckIfHasContact, FirstContact, ListContactsWithoutProspecting, } from '@/clients/llm';
import { Component, Prop, Vue } from 'vue-property-decorator';
import JsonFormat from './JsonFormat.vue';
import TextFormat from './TextFormat.vue';
import { companyFields, decisorFields } from '@/shared/utils/translate';
import Loading from './Loading.vue';
let WithoutProspecting = class WithoutProspecting extends Vue {
    constructor() {
        super(...arguments);
        this.contacts = [];
        this.total = 0;
        this.loading = true;
        this.otherContacts = null;
    }
    async mounted() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.infoSetId = this.$route.params.infoSetId;
        this.department = urlParams.get('departamento-decisor') || '';
        this.position = urlParams.get('posicao-decisor') || '';
        this.level = urlParams.get('nivel-decisor') || '';
        await this.listContactsWithoutProspecting();
        this.loading = false;
    }
    async listContactsWithoutProspecting() {
        try {
            const response = await ListContactsWithoutProspecting(this.channel, this.infoSetId, {
                department: this.splitFilter(this.department),
                position: this.splitFilter(this.position),
                level: this.splitFilter(this.level),
            }, this.page, this.limit);
            this.contacts = response.data.contacts.map(contact => {
                return {
                    ...companyFields(contact),
                    ...(this.showDecisorFields
                        ? decisorFields(contact.decisor)
                        : { whatsapp: contact.whatsapp }),
                };
            });
            this.total = response.data.total;
            if (this.total == 0) {
                const response_has_contacts = await CheckIfHasContact(this.infoSetId);
                console.log(response_has_contacts.data);
                this.otherContacts = response_has_contacts.data;
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    splitFilter(filter) {
        return filter
            .split(',')
            .map(f => f.trim())
            .filter(f => f);
    }
    async markAsContacted(contact) {
        try {
            await FirstContact(this.infoSetId, contact['id da empresa'], this.channel, contact[this.classKey]);
            this.listContactsWithoutProspecting();
        }
        catch (e) {
            console.log(e);
        }
    }
    get showDecisorFields() {
        return this.channel !== 'whatsapp';
    }
    get classKey() {
        switch (this.channel) {
            case 'linkedin':
                return 'linkedin do decisor';
            case 'email':
                return 'email do decisor';
            case 'whatsapp':
                return 'whatsapp';
            default:
                return '';
        }
    }
    get withoutContactsMessage() {
        if ((this.department != '' || this.position != '' || this.level != '') &&
            this.channel != 'whatsapp') {
            return `
        Não foram encontrados contatos de ${this.channel} nessa lista com os filtros utilizados. Tente outro
        canal, modifique os filtros atuais ou gere uma nova lista com mais empresas.
      `;
        }
        return `
      Não foram encontrados contatos de ${this.channel} nessa lista. Tente outro
      canal ou gere uma nova lista com mais empresas.
    `;
    }
};
__decorate([
    Prop({ default: () => 'linkedin' })
], WithoutProspecting.prototype, "channel", void 0);
__decorate([
    Prop({ default: () => 'json' })
], WithoutProspecting.prototype, "format", void 0);
__decorate([
    Prop({ default: () => 1 })
], WithoutProspecting.prototype, "page", void 0);
__decorate([
    Prop({ default: () => 10 })
], WithoutProspecting.prototype, "limit", void 0);
WithoutProspecting = __decorate([
    Component({
        name: 'WithoutProspecting',
        components: { JsonFormat, TextFormat, Loading },
    })
], WithoutProspecting);
export default WithoutProspecting;
